var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Steps } from "antd";
import { Container } from "./TableAddFormSteps.style";
export var TableAddFormSteps = function (_a) {
    var t = _a.t, props = __rest(_a, ["t"]);
    return (_jsx(Container, { children: _jsxs(Steps, __assign({}, props, { onChange: function () { return false; }, children: [_jsx(Steps.Step, { title: t("tableManagement.addAndEdit.steps.step1") }), _jsx(Steps.Step, { title: t("tableManagement.addAndEdit.steps.step2") }), _jsx(Steps.Step, { title: t("tableManagement.addAndEdit.steps.step3") })] })) }));
};
export default TableAddFormSteps;
